// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ug8-7"};